export default __webpack_public_path__ + "static/media/awn1.aaee6155.svg";